import ServicePageLayout from "@/components/ServicePageLayout";

export default function TalentAdvisoryPage() {
  return (
    <ServicePageLayout
      testId="page-talent-advisory"
      eyebrow="ArcPoint Advisory"
      title="Talent Advisory."
      intro={[
        "Understand the leadership market before making the hire.",
        "ArcPoint provides founders and leadership teams with market intelligence around organisational structure, senior talent availability, compensation and competitor leadership.",
        "This can be used independently or before launching a retained search.",
      ]}
      areasTitle="Market intelligence, organisational design and leadership strategy."
      areas={[
        "Leadership market mapping",
        "Organisational design",
        "Competitor talent intelligence",
        "Compensation benchmarking",
        "Succession planning",
        "Leadership team architecture",
        "Pre-funding and post-funding hiring strategy",
      ]}
      deepTitle="Intelligence before recruitment."
      deepBody={[
        "Sometimes the first question isn't \"Who should we hire?\"",
        "It's understanding what the role should actually look like, where the relevant talent sits and what the market will require to attract it.",
        "ArcPoint can map those questions before an organisation commits to a search.",
      ]}
      ctaLabel="Start a confidential conversation"
    />
  );
}
